var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"breadcrumb"},_vm._l((_vm.routerList),function(item,index){return _c('div',{key:index,staticClass:"text",style:(index == _vm.routerList.length - 1 ? 'color:#F58030' : ''),on:{"click":function($event){return _vm.jump(item)}}},[_vm._v(" "+_vm._s(index == _vm.routerList.length - 1 ? item : item + ' / ')+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }